import React from "react";
import { FaEye } from "react-icons/fa";
import "./Icons.scss";
const ViewIcon = ({ className }) => {
  return (
    <button type="button" className="add-documents-button">
    <FaEye className={className} />
    </button>
  );
};

export default ViewIcon;
